import cakeLps from "@/domain/tokens/cakeLps";

export const saunaPerBnb = async (web3) => {
  const lpPool = cakeLps[0];

  let lpPoolContract = new web3.eth.Contract(
    lpPool.abi,
    lpPool.contractAddress
  );

  let reserves = await lpPoolContract.methods.getReserves().call();

  return reserves[0] / reserves[1];
};

export const steamPerBnb = async (web3) => {
  const lpPool = cakeLps[1];

  let lpPoolContract = new web3.eth.Contract(
    lpPool.abi,
    lpPool.contractAddress
  );

  let reserves = await lpPoolContract.methods.getReserves().call();

  return (reserves[0] * 1e9) / reserves[1];
};

export const ssctPerBnb = async (web3) => {
  const lpPool = cakeLps[2];

  let lpPoolContract = new web3.eth.Contract(
    lpPool.abi,
    lpPool.contractAddress
  );

  let reserves = await lpPoolContract.methods.getReserves().call();

  return reserves[0] / reserves[1];
};

export const boilerPerBusd = async (web3) => {
  const lpPool = cakeLps[3];

  let lpPoolContract = new web3.eth.Contract(
    lpPool.abi,
    lpPool.contractAddress
  );

  let reserves = await lpPoolContract.methods.getReserves().call();

  return reserves[1] / reserves[0];
};

export const boilerPerUsdt = async (web3) => {
  const lpPool = cakeLps[4];

  let lpPoolContract = new web3.eth.Contract(
    lpPool.abi,
    lpPool.contractAddress
  );

  let reserves = await lpPoolContract.methods.getReserves().call();

  return reserves[0] / reserves[1];
};

export const boilerPerUsdc = async (web3) => {
  const lpPool = cakeLps[5];

  let lpPoolContract = new web3.eth.Contract(
    lpPool.abi,
    lpPool.contractAddress
  );

  let reserves = await lpPoolContract.methods.getReserves().call();

  return reserves[0] / reserves[1];
};
